<template>
    <div>
        <slot :closeAllDialog="closeAllDialog" :openTicketsDialog="openTicketsDialog" :openSubscribeDialog="openSubscribeDialog" :openPriceDialog="openPriceDialog"></slot>
    </div>
</template>

<script>
import { defineComponent, onMounted, ref } from 'vue';
export default defineComponent({
    name: 'SeriesPackHeader',
    props: {
        event: {
            type: Object,
            required: true,
        },
        openticketsdialog: {
            type: Function,
            required: true,
        },
        opensubscribedialog: {
            type: Function,
            required: true,
        },
        openpricedialog: {
            type: Function,
            required: true,
        }
    },
    setup(props) {
        const ticketsDialog = ref(null);
        const subscribeDialog = ref(null);
        const priceDialog = ref(null);
        const openTicketsDialog = (() => {
            ticketsDialog.value.showModal();
            props.openticketsdialog(props.event);
        });
        const openSubscribeDialog = (() => {
            subscribeDialog.value.showModal();
            props.opensubscribedialog(props.event);
        });
        const openPriceDialog = (() => {
            priceDialog.value.showModal();
            props.openpricedialog(props.event);
        });
        const closeAllDialog = (() => {
            const closePrice = document.getElementById('series-price-popup');
            const closeSubscribe = document.getElementById('series-book-popup');
            const closeTickets = document.getElementById('series-package-popup');
            closeTickets.close();
            closePrice.close();
            closeSubscribe.close();
        });
        onMounted(() => {
            ticketsDialog.value = document.getElementById('series-package-popup');
            subscribeDialog.value = document.getElementById('series-book-popup');
            priceDialog.value = document.getElementById('series-price-popup');
        })
        return {
            openTicketsDialog,
            openSubscribeDialog,
            openPriceDialog,
            closeAllDialog
        };
    },
});
</script>